const isDebugLoggingEnabled = () => (
  import.meta.env.DEV &&
  import.meta.env.VITE_ENABLE_FRONTEND_DEBUG_LOGS === 'true'
);

const hasAxiosShape = (value) => (
  value &&
  typeof value === 'object' &&
  ('isAxiosError' in value || 'response' in value || 'request' in value || 'config' in value)
);

export const getSafeErrorDetails = (error) => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  // Browser console output is visible to end users and support operators. Keep
  // operationally useful metadata, but never print response bodies, request
  // config, headers, tokens, entity payloads, or full user objects.
  const details = {};
  const status = error.response?.status || error.status;
  const statusText = error.response?.statusText;
  const method = error.config?.method;

  if (error.name) details.name = error.name;
  if (error.message) details.message = error.message;
  if (error.code) details.code = error.code;
  if (status) details.status = status;
  if (statusText) details.statusText = statusText;
  if (method) details.method = String(method).toUpperCase();

  return Object.keys(details).length > 0 ? details : undefined;
};

const normalizeDetails = (details) => {
  if (details instanceof Error || hasAxiosShape(details)) {
    return getSafeErrorDetails(details);
  }

  return details;
};

const logWithDetails = (method, message, details) => {
  const normalizedDetails = normalizeDetails(details);

  if (normalizedDetails === undefined) {
    console[method](message);
    return;
  }

  console[method](message, normalizedDetails);
};

const logger = {
  debug(message, details) {
    if (isDebugLoggingEnabled()) {
      logWithDetails('debug', message, details);
    }
  },

  info(message, details) {
    if (isDebugLoggingEnabled()) {
      logWithDetails('info', message, details);
    }
  },

  warn(message, details) {
    logWithDetails('warn', message, details);
  },

  error(message, details) {
    logWithDetails('error', message, details);
  }
};

export default logger;
